module.exports = __webpack_public_path__ + "img/barcode-read.d3d94563.svg";